// extracted by mini-css-extract-plugin
module.exports = {"button":"Footer_button__E5p7j","ar-canvas":"Footer_ar-canvas__2Z6Zu","instModal":"Footer_instModal__1bHJ0","active":"Footer_active__3wB70","footer":"Footer_footer__7dIj9"};